module.exports = __webpack_public_path__ + "img/PDF.4fd35d29.png";